import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, hasStaffRole } from '@nebalkon-workspace/auth';
import {
  CABINET_PATHS,
  isClientCabinetPathFor,
} from '@nebalkon-workspace/cabinet-core';
import { environment } from '@nebalkon-workspace/environments';
import { isTelegramMiniApp } from '../utils/telegram-mini-app';

/**
 * Marks API requests as mobile client. Adds `X-Cabinet: client` for staff in
 * `/client/**` so client endpoints are not blocked by staff JWT roles.
 * Telegram Mini App uses `X-Client: telegram` for HTTPS payment return URLs.
 */
export const mobileClientInterceptor: HttpInterceptorFn = (req, next) => {
  const base = environment.apiUrl;
  if (!req.url.startsWith(base)) {
    return next(req);
  }
  const router = inject(Router);
  const authService = inject(AuthService);
  const cabinetPaths = inject(CABINET_PATHS);
  const url = router.url.split('?')[0];

  const headers: Record<string, string> = {
    'X-Client': isTelegramMiniApp() ? 'telegram' : 'mobile',
  };
  if (isTelegramMiniApp() && typeof window !== 'undefined') {
    headers['X-App-Origin'] = window.location.origin;
  }
  if (
    isClientCabinetPathFor(cabinetPaths, url) &&
    hasStaffRole(authService.roles())
  ) {
    headers['X-Cabinet'] = 'client';
  }

  return next(req.clone({ setHeaders: headers }));
};
